import { Directive, forwardRef, inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';

@Directive({
  selector: '[appValueAccessor]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ValueAccessorDirective),
    },
  ],
})
export class ValueAccessorDirective<T> implements OnInit, ControlValueAccessor, OnDestroy {
  ngControl!: NgControl | null;
  private injector = inject(Injector);
  private onChange!: (value: T) => void;
  private onTouched!: (value: boolean) => void;
  private valueSubject = new Subject<T>();
  private disabledSubject = new Subject<boolean>();
  readonly value = this.valueSubject.asObservable();
  readonly disabled = this.disabledSubject.asObservable();

  ngOnDestroy(): void {
    this.valueSubject.complete();
    this.disabledSubject.complete();
  }
  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null, { self: true });
  }

  valueChange(v: T) {
    try {
      this.onChange(v);
    } catch (error) {
      console.warn('Form control not provided.');
    }
  }

  touchedChange(v: boolean) {
    try {
      this.onTouched(v);
    } catch (error) {
      console.warn('Form control not provided.');
    }
  }

  writeValue(obj: T): void {
    this.valueSubject.next(obj);
  }

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: (value: boolean) => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledSubject.next(isDisabled);
  }
}
